var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "btn-group btn-group-sm mb-2",
          attrs: { "data-toggle": "buttons" }
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-success",
              attrs: {
                type: "button",
                "data-toggle": "modal",
                "data-target": "#addModal"
              }
            },
            [_vm._v(_vm._s(_vm.$t("btnAdd")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-danger",
              attrs: {
                disabled: _vm.selectedIndex.length !== 1,
                id: "deleteBtn",
                "data-toggle": "modal",
                "data-target": "#confirmModal"
              }
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("btnDelete")) + "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-warning",
              attrs: {
                disabled: _vm.selectedIndex.length !== 1,
                id: "editBtn"
              },
              on: {
                click: function($event) {
                  return _vm.editSelected()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("btnEdit")))]
          )
        ]
      ),
      _vm._v(" "),
      _c("vue-good-table", {
        attrs: {
          columns: _vm.columnsConfig,
          rows: _vm.oeeSettingsPage,
          "pagination-options": {
            enabled: true,
            nextLabel: _vm.$t("txtNext"),
            prevLabel: _vm.$t("txtPrev"),
            rowsPerPageLabel: _vm.$t("txtPagePer"),
            ofLabel: _vm.$t("txtOf"),
            pageLabel: _vm.$t("txtPage"),
            allLabel: _vm.$t("txtAll")
          },
          "select-options": _vm.selectConfig,
          "search-options": { enabled: true, placeholder: _vm.$t("txtSearch") }
        },
        on: { "on-selected-rows-change": _vm.selectionChanged }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "addModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "myModalLabel"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-lg",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h4",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "myModalLabel" }
                    },
                    [_vm._v(_vm._s(_vm.$t("txtOeeConfig")))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("table", { staticClass: "table" }, [
                    _c("thead", { staticClass: "table-primary" }, [
                      _c("tr", [
                        _c(
                          "td",
                          [
                            _c("small", [_vm._v(_vm._s(_vm.$t("txtCell")))]),
                            _vm._v(" "),
                            _c("vue-select", {
                              attrs: {
                                label: "name",
                                options: _vm.cells,
                                reduce: name => name.id
                              },
                              model: {
                                value: _vm.newSetting.fKCellId,
                                callback: function($$v) {
                                  _vm.$set(_vm.newSetting, "fKCellId", $$v)
                                },
                                expression: "newSetting.fKCellId"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c("small", [
                            _vm._v(_vm._s(_vm.$t("txtOeeQualityRatio")))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.defaultQualityRatio,
                                expression: "newSetting.defaultQualityRatio"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: {
                              value: _vm.newSetting.defaultQualityRatio
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "defaultQualityRatio",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("small", [
                            _vm._v(
                              _vm._s(_vm.$t("txtOeeDefaultProductionTimeMin"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.newSetting
                                    .defaultPlannedProductionTimeMin,
                                expression:
                                  "newSetting.defaultPlannedProductionTimeMin"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: {
                              value:
                                _vm.newSetting.defaultPlannedProductionTimeMin
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "defaultPlannedProductionTimeMin",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tbody", [
                      _c("tr", [
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.ignServer,
                                expression: "newSetting.ignServer"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("txtIgnServer")
                            },
                            domProps: { value: _vm.newSetting.ignServer },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "ignServer",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.ignDb,
                                expression: "newSetting.ignDb"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("txtIgnDb")
                            },
                            domProps: { value: _vm.newSetting.ignDb },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "ignDb",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.ignUser,
                                expression: "newSetting.ignUser"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("txtIgnUser")
                            },
                            domProps: { value: _vm.newSetting.ignUser },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "ignUser",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.ignPwd,
                                expression: "newSetting.ignPwd"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "password",
                              placeholder: _vm.$t("txtignPwd")
                            },
                            domProps: { value: _vm.newSetting.ignPwd },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "ignPwd",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.ignTable,
                                expression: "newSetting.ignTable"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("txtIgnTable")
                            },
                            domProps: { value: _vm.newSetting.ignTable },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "ignTable",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.ignIndex,
                                expression: "newSetting.ignIndex"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("txtIgnIndex")
                            },
                            domProps: { value: _vm.newSetting.ignIndex },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "ignIndex",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.ignFieldValue,
                                expression: "newSetting.ignFieldValue"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("txtIgnField")
                            },
                            domProps: { value: _vm.newSetting.ignFieldValue },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "ignFieldValue",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.ignFieldTimestmp,
                                expression: "newSetting.ignFieldTimestmp"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("txtIgnFieldTimestmp")
                            },
                            domProps: {
                              value: _vm.newSetting.ignFieldTimestmp
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "ignFieldTimestmp",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.ignFieldCell,
                                expression: "newSetting.ignFieldCell"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("txtIgnFieldCell")
                            },
                            domProps: { value: _vm.newSetting.ignFieldCell },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "ignFieldCell",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.ignScanRate,
                                expression: "newSetting.ignScanRate"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("txtIgnScanRate")
                            },
                            domProps: { value: _vm.newSetting.ignScanRate },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "ignScanRate",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newSetting.shortstopSeconds,
                                expression: "newSetting.shortstopSeconds"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("txtShortstop")
                            },
                            domProps: {
                              value: _vm.newSetting.shortstopSeconds
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.newSetting,
                                  "shortstopSeconds",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td")
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function($event) {
                          return _vm.postSetting()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("btnSave")))]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "confirmModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "myModalLabel"
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h4",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "myModalLabel" }
                    },
                    [_vm._v(_vm._s(_vm.$t("txtDelete")))]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("txtOeeDelete")) +
                        "\n                    "
                    ),
                    _vm._l(_vm.selectedIndex, function(item, index) {
                      return _c("div", [
                        _c("span", [_vm._v(_vm._s(item.cellName))])
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [_vm._v(_vm._s(_vm.$t("btnClose")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function($event) {
                          return _vm.deleteSelected()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("btnDelete")))]
                  )
                ])
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }